import React from 'react'

function Error() {
  return (
    <div>404 Not found</div>
  )
}

export default Error;